import Breadcrumb from "../components/Breadcrumb";
import VehicleMakeslayer from "../components/VehicleMakeslayer";


const VehicleMakesPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Vehicle makes" />

      <VehicleMakeslayer />
    </>
  );
};

export default VehicleMakesPage;
